/*
 * PERLOTUS PREMIUM V3 — uzun ürün açıklamasını daraltma
 *
 * Yalnızca sunum: açıklama metni sayfada aynen kalır, uzunsa görsel olarak katlanır ve
 * altına "Devamını oku" butonu eklenir. Ürün formuna, kişiselleştirme koduna ve sepete
 * dokunmaz. Varyant değişiminde Sense açıklamayı yeniden çizerse tekrar uygulanır.
 */

(function () {
  var COLLAPSE_AFTER = 720;
  var LABEL_MORE = 'Açıklamanın devamını oku';
  var LABEL_LESS = 'Açıklamayı daralt';

  function enhance(description) {
    if (!description || description.dataset.pv3Desc) return;
    description.dataset.pv3Desc = 'true';
    if (description.scrollHeight < COLLAPSE_AFTER) return;

    description.classList.add('pv3-desc--collapsed');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'pv3-desc__toggle';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = LABEL_MORE;
    button.addEventListener('click', function () {
      var collapsed = description.classList.toggle('pv3-desc--collapsed');
      button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      button.textContent = collapsed ? LABEL_MORE : LABEL_LESS;
      if (collapsed) description.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    description.insertAdjacentElement('afterend', button);
  }

  function run() {
    document.querySelectorAll('.product__info-container .product__description').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var root = document.querySelector('product-info') || document.querySelector('.product__info-container');
  if (root && 'MutationObserver' in window) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }).observe(root, { childList: true, subtree: true });
  }
})();
